import React, { useState, useEffect } from "react";
import axios from "axios";
import { Link, useParams } from "react-router-dom";
import './Main_labels.css'
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import Response_Loading_processing from "../../../../layout/Others/Response_Loading_processing";
import backarrow from "../../../../components/Images/backarrow.svg";
import { FaSearch } from "react-icons/fa";
import './Labels.css'
import AdminBackNavigation from "../../../../components/CommonComponents/AdminBackNavigation";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

function Label_source_list(props) {
    const { id } = useParams();
    const [getVideolists, setVideolists] = useState([]);
    const [loading, setLoading] = useState(true);
    const [processing, setProcessing] = useState(false);
    const [showOverlay, setShowOverlay] = useState(false);
    const [searchTerm, setSearchTerm] = useState("");

    const access_token = localStorage.getItem("access_token");
    const headers = {
        "Content-Type": "application/json",
        Authorization: "Bearer " + access_token,
        Accept: "application/json",
        "Access-Control-Allow-Origin": "*",
    };

    const capitalizeAfterDash = (str) => {
        return str
            .split('-')
            .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
            .join(' ');
    };

    const formattedString = capitalizeAfterDash(id);

    useEffect(() => {
        const fetchDatavideo = async () => {
            try {
                const response = await axios.get(
                    `${process.env.REACT_APP_Baseurl}/admin/Label-Management/list-source`,
                    {
                        headers: headers,
                        params: { source: id },
                    }
                );
                setVideolists(response?.data?.label_management);
                setLoading(false);
            } catch (error) {
                console.error("Error fetching data:", error);
                setLoading(false);
            }
        };

        fetchDatavideo();
    }, []);

    async function handleUpdatevideo(updatedItem) {
        const formData = new URLSearchParams();
        formData.append("title", updatedItem?.title);
        formData.append("sub_title", updatedItem?.sub_title);
        // formData.append("redirection_path", updatedItem?.redirection_path);

        let firstApiStatus = false;
        let resultapi = null;
        setProcessing(true);
        setShowOverlay(true);

        try {
            const response = await axios.post(
                `${process.env.REACT_APP_Baseurl}/admin/Label-Management/update/${updatedItem?.id}`,
                formData,
                {
                    headers: {
                        ...headers,
                        'Content-Type': 'application/x-www-form-urlencoded'
                    }
                }
            );

            if (response?.data?.status === true) {
                firstApiStatus = true;
                resultapi = response?.data;

                const updatedList = [...getVideolists];
                const itemIndex = updatedList?.findIndex((item) => item?.id === updatedItem?.id);

                if (itemIndex !== -1) {
                    updatedList[itemIndex] = { ...updatedList[itemIndex], ...updatedItem };
                    setVideolists(updatedList);
                }
            }
        } catch (error) { }

        if (resultapi) {
            if (firstApiStatus) {
                if (resultapi?.message) {
                    toast.success(resultapi?.message);
                }
            } else {
                if (resultapi?.status === false) {
                    if (resultapi?.message) {
                        toast.error(resultapi?.message);
                    }
                    setProcessing(false);
                    setShowOverlay(false);
                }
            }
        }
    }

    const filteredVideoLists = getVideolists?.filter((item) =>
        item?.title?.toLowerCase().includes(searchTerm?.toLowerCase())
    );

    // Pagination Logic
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 10;
    const totalPages = Math.ceil(filteredVideoLists.length / itemsPerPage);
    const startIndex = (currentPage - 1) * itemsPerPage;
    const endIndex = startIndex + itemsPerPage;
    const currentItems = filteredVideoLists.slice(startIndex, endIndex);

    return (
        <>
            <AdminBackNavigation path="/labels" text="Back" />
            <section className="section Label_settings container-fluid pt-3">
                <div className="row">
                    <div className="col-sm-12">
                        <div className="iq-card-body table-responsive iq-card">
                            <div className="col-lg-12 row">
                                <div className="col-lg-6 col-md-6 col-sm-6 col-6">
                                    <h4 className="admin-title mb-0 theme-text-color text-md-start">{formattedString}</h4>
                                </div>
                            </div>

                            <section className="section container-fluid">
                                <div id="content-page" className="content-page">
                                    <div className="mt-3">
                                        <div className="bootstrapTable ">
                                            <div className="col-12 p-0">
                                                <div className="row m-0 p-0">
                                                    <div className="col-lg-3 col-sm-3 col-3 data">
                                                        <p className="theme-text-color mb-3 mt-0 admin-input-title d-block position-relative ms-4">Text</p>
                                                    </div>
                                                    <div className="col-lg-3 col-sm-3 col-3 data">
                                                        <p className="theme-text-color mb-3 mt-0 admin-input-title d-block position-relative ms-4">Sub Text</p>
                                                    </div>
                                                    <div className="col-lg-3 col-sm-3 col-3 data text-center">
                                                        <p className="theme-text-color mb-3 mt-0 admin-input-title d-block position-relative me-3">Path</p>
                                                    </div>
                                                    <div className="col-lg-3 col-sm-3 col-3 data text-center">
                                                        <p className="theme-text-color mb-3 mt-0 admin-input-title d-block position-relative me-3">Actions</p>
                                                    </div>
                                                </div>

                                                <DragDropContext>
                                                    <Droppable droppableId="menu-items">
                                                        {(provided) => (
                                                            <ul {...provided.droppableProps} ref={provided.innerRef}>
                                                                {loading ? (
                                                                    <div className="noRecord">
                                                                        <Response_Loading_processing />
                                                                        Loading...
                                                                    </div>
                                                                ) : currentItems?.length <= 0 ? (
                                                                    <div className="noRecord">
                                                                        <p>No Sidebar Available !!!</p>
                                                                    </div>
                                                                ) : (
                                                                    currentItems?.map((item, index) => (
                                                                        <Draggable
                                                                            key={item.id}
                                                                            draggableId={item.id.toString()}
                                                                            index={index}
                                                                        >
                                                                            {(provided) => (
                                                                                <li
                                                                                    ref={provided.innerRef}
                                                                                    {...provided.draggableProps}
                                                                                    {...provided.dragHandleProps}
                                                                                    className={`bg-white orderborder ${item?.order
                                                                                        } index ${index + 1} w-100`}
                                                                                >
                                                                                    <div className="row m-0 p-0 align-items-center">
                                                                                        <div className="col-lg-3 col-sm-3 col-3 data_th">
                                                                                            <input
                                                                                                type="text"
                                                                                                className="rs-input form-control-lg"
                                                                                                value={item?.title}
                                                                                                onChange={(e) => {
                                                                                                    const newName = e.target.value;
                                                                                                    const updatedList = [...getVideolists];
                                                                                                    updatedList.find(i => i.id === item.id).title = newName;
                                                                                                    setVideolists(updatedList);
                                                                                                }}
                                                                                            />
                                                                                        </div>
                                                                                        <div className="col-lg-3 col-sm-3 col-3 data_th">
                                                                                            <input
                                                                                                type="text"
                                                                                                className="rs-input form-control-lg"
                                                                                                value={item?.sub_title}
                                                                                                onChange={(e) => {
                                                                                                    const newName = e.target.value;
                                                                                                    const updatedList = [...getVideolists];
                                                                                                    updatedList.find(i => i.id === item.id).sub_title = newName;
                                                                                                    setVideolists(updatedList);
                                                                                                }}
                                                                                            />
                                                                                        </div>
                                                                                        <div className="col-lg-3 col-sm-3 col-3 data_th">
                                                                                            <input
                                                                                                type="text"
                                                                                                className="rs-input form-control-lg"
                                                                                                value={item?.redirection_path}
                                                                                                disabled
                                                                                                onChange={(e) => {
                                                                                                    const newName = e.target.value;
                                                                                                    const updatedList = [...getVideolists];
                                                                                                    updatedList.find(i => i.id === item.id).redirection_path = newName;
                                                                                                    setVideolists(updatedList);
                                                                                                }}
                                                                                            />
                                                                                        </div>
                                                                                        <div className="col-lg-3 col-sm-3 col-3 data_th text-center">
                                                                                            <div className="justify-content-between align-items-center">
                                                                                                <button className="button-bg-color theme-button-text-color admin-button-text rounded-3 py-2 px-3" onClick={() => handleUpdatevideo(item)}>Update</button>
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>
                                                                                </li>
                                                                            )}
                                                                        </Draggable>
                                                                    ))
                                                                )}
                                                                {provided.placeholder}
                                                            </ul>
                                                        )}
                                                    </Droppable>
                                                </DragDropContext>

                                                {/* Pagination UI */}

                                                <div className="row col-lg-12">
                                                    <div className="col-lg-4">
                                                    </div>

                                                    <div className=" col-lg-4">
                                                        <div className="d-flex justify-content-center my-2 align-items-end p-4">
                                                            <div style={{
                                                            }}>
                                                                {currentPage}
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className=" col-lg-4">
                                                        {!loading && filteredVideoLists.length > itemsPerPage && (
                                                            <>
                                                                {/* Current Page Display */}


                                                                {/* Pagination */}
                                                                <div className=" d-flex justify-content-end mt-2">
                                                                    <ul className="pagination">

                                                                        {/* First Button */}

                                                                        {currentPage > 1 && (
                                                                            <li
                                                                                className="page-item"
                                                                                onClick={() => setCurrentPage(1)}
                                                                                style={{ cursor: "pointer", marginRight: "10px" }}
                                                                            >
                                                                                <span className="page-link">{"<<<"}</span>
                                                                            </li>
                                                                        )}

                                                                        {/* Previous Button */}
                                                                        {currentPage > 1 && (
                                                                            <li
                                                                                className="page-item"
                                                                                onClick={() => setCurrentPage(currentPage - 1)}
                                                                                style={{ cursor: "pointer", marginRight: "10px" }}
                                                                            >
                                                                                <span className="page-link">{"<"}</span>
                                                                            </li>
                                                                        )}

                                                                        {/* Page Numbers: show sliding window of 4 pages */}
                                                                        {Array.from({ length: totalPages }, (_, i) => i + 1)
                                                                            .filter(page =>
                                                                                page >= Math.max(currentPage - 0, 1) &&
                                                                                page <= Math.min(currentPage + 1, totalPages)
                                                                            )
                                                                            .map(page => (
                                                                                <li
                                                                                    key={page}
                                                                                    className={`page-item ${currentPage === page ? 'active' : ''}`}
                                                                                    onClick={() => setCurrentPage(page)}
                                                                                    style={{ cursor: "pointer", margin: "0 5px" }}
                                                                                >
                                                                                    <span className="page-link">{page}</span>
                                                                                </li>
                                                                            ))}

                                                                        {/* Next Button */}
                                                                        {currentPage < totalPages && (
                                                                            <li
                                                                                className="page-item"
                                                                                onClick={() => setCurrentPage(currentPage + 1)}
                                                                                style={{ cursor: "pointer", marginLeft: "10px" }}
                                                                            >
                                                                                <span className="page-link">{">"}</span>
                                                                            </li>
                                                                        )}

                                                                        {/* End Button */}
                                                                        {currentPage < totalPages && (
                                                                            <li
                                                                                className="page-item"
                                                                                onClick={() => setCurrentPage(totalPages)}
                                                                                style={{ cursor: "pointer", marginLeft: "10px" }}
                                                                            >
                                                                                <span className="page-link">{">>>"}</span>
                                                                            </li>
                                                                        )}
                                                                    </ul>
                                                                </div>
                                                            </>
                                                        )}
                                                    </div>
                                                </div>
                                                {/* End Pagination UI */}

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </section>
                        </div>
                    </div>
                </div >
            </section >
        </>
    );
}

export default Label_source_list;



// import React, { useState, useEffect } from "react";
// import axios from "axios";
// import { Link, useParams } from "react-router-dom";
// import './Main_labels.css'
// import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
// import Response_Loading_processing from "../../../../layout/Others/Response_Loading_processing";
// import backarrow from "../../../../components/Images/backarrow.svg";
// import { FaSearch } from "react-icons/fa";
// import './Labels.css'
// import AdminBackNavigation from "../../../../components/CommonComponents/AdminBackNavigation";
// import { toast } from 'react-toastify';
// import 'react-toastify/dist/ReactToastify.css';


// function Label_source_list(props) {

//     const { id } = useParams();
//     const [getVideolists, setVideolists] = useState([]);
//     const [loading, setLoading] = useState(true);
//     const [processing, setProcessing] = useState(false);
//     const [showOverlay, setShowOverlay] = useState(false);
//     const [searchTerm, setSearchTerm] = useState(""); // New state for search term

//     const access_token = localStorage.getItem("access_token");
//     const headers = {
//         "Content-Type": "application/json",
//         Authorization: "Bearer " + access_token,
//         Accept: "application/json",
//         "Access-Control-Allow-Origin": "*",
//     };

//     const capitalizeAfterDash = (str) => {
//         return str
//             .split('-') // Split by hyphen
//             .map((word) => word.charAt(0).toUpperCase() + word.slice(1)) // Capitalize first letter
//             .join(' '); // Join back with a space
//     };

//     const formattedString = capitalizeAfterDash(id);


//     useEffect(() => {
//         const fetchDatavideo = async () => {
//             try {
//                 const response = await axios.get(
//                     `${process.env.REACT_APP_Baseurl}/admin/Label-Management/list-source`,
//                     {
//                         headers: headers,
//                         params: { source: id },
//                     }
//                 );
//                 setVideolists(response?.data?.label_management);
//                 setLoading(false);
//             } catch (error) {
//                 console.error("Error fetching data:", error);
//                 setLoading(false);
//             }
//         };

//         fetchDatavideo();
//     }, []);

//     async function handleUpdatevideo(updatedItem) {
//         const formData = new URLSearchParams();

//         formData.append("title", updatedItem?.title);
//         formData.append("sub_title", updatedItem?.sub_title);
//         formData.append("path", updatedItem?.path);

//         let firstApiStatus = false;
//         let resultapi = null;
//         setProcessing(true);
//         setShowOverlay(true);

//         try {
//             const response = await axios.post(
//                 `${process.env.REACT_APP_Baseurl}/admin/Label-Management/update/${updatedItem?.id}`,
//                 formData,
//                 {
//                     headers: {
//                         ...headers,
//                         'Content-Type': 'application/x-www-form-urlencoded' // Specify the content type
//                     }
//                 }

//             );

//             if (response?.data?.status === true) {
//                 firstApiStatus = true;

//                 resultapi = response?.data;

//                 // Update the local state with the updated data
//                 const updatedList = [...getVideolists];
//                 const itemIndex = updatedList?.findIndex((item) => item?.id === updatedItem?.id);

//                 if (itemIndex !== -1) {
//                     updatedList[itemIndex] = { ...updatedList[itemIndex], ...updatedItem };
//                     setVideolists(updatedList);
//                 }
//             }
//         } catch (error) { }

//         // if (firstApiStatus) {
//         //     props.setApiresponsealert(resultapi);
//         //     props.setShowalert(true);
//         // } else {
//         //     if (resultapi && resultapi.status === false) {
//         //         var resultError = resultapi;
//         //         props.setApiresponsealert(resultError);
//         //         props.setShowalert(false);
//         //         setProcessing(false);
//         //         setShowOverlay(false);
//         //     }
//         // }
//         if (resultapi) {
//             if (firstApiStatus) {
//                 if (resultapi?.message) {
//                     toast.success(resultapi?.message);
//                 }
//             } else {
//                 if (resultapi?.status === false) {
//                     if (resultapi?.message) {
//                         toast.error(resultapi?.message);
//                     }
//                     setProcessing(false);
//                     setShowOverlay(false);
//                 }
//             }
//         }
//     }

//     // Filter the video lists based on searchTerm
//     const filteredVideoLists = getVideolists?.filter((item) =>
//         item?.title?.toLowerCase().includes(searchTerm?.toLowerCase())
//     );

//     return (
//         <>
//             <AdminBackNavigation path="/labels" text="Back" />
//             {/* <Link to="/labels" className="backarrow">
//                 <img src={backarrow} alt="flogo" width={20} height={20} />{" "}
//                 <span> Back</span>
//             </Link> */}


//             <section className="section Label_settings container-fluid pt-3">
//                 <div className="row">
//                     <div className="col-sm-12">

//                         <div className="iq-card-body table-responsive iq-card">
//                             <div className="col-lg-12 row">
//                                 <div className="col-lg-6 col-md-6 col-sm-6 col-6">
//                                     <h4 className="admin-title mb-0 theme-text-color text-md-start">{formattedString}</h4>
//                                 </div>
//                                 {/* <div className="col-lg-6 col-md-6 col-sm-6 col-12 text-end">
//                                     <div className="row mb-3">
//                                         <input
//                                             type="text"
//                                             className="form-control"
//                                             placeholder="Search by Text"
//                                             value={searchTerm}
//                                             onChange={(e) => setSearchTerm(e.target.value)}
//                                         />
//                                     </div>
//                                     <div className="searchPageIconFaSearchtranssearchPageIconFaSearchtrans">
//                                         <FaSearch
//                                             className="searchPageIconFaSearchtranssearchPageIconFaSearchtrans p-1 fs-5"
//                                             value={searchTerm}
//                                             onChange={(e) => setSearchTerm(e.target.value)}
//                                         />
//                                     </div>
//                                 </div> */}
//                             </div>

//                             <section className="section container-fluid">
//                                 <div id="content-page" className="content-page">
//                                     <div className="mt-3">
//                                         <div className="bootstrapTable ">
//                                             <div className="col-12 p-0">
//                                                 <div className="row m-0 p-0">
//                                                     <div className="col-lg-3 col-sm-3 col-3 data">
//                                                         {" "}
//                                                         <p className="theme-text-color mb-3 mt-0 admin-input-title d-block position-relative ms-4">Text</p>
//                                                     </div>
//                                                     <div className="col-lg-3 col-sm-3 col-3 data">
//                                                         {" "}
//                                                         <p className="theme-text-color mb-3 mt-0 admin-input-title d-block position-relative ms-4">Sub Text</p>
//                                                     </div>
//                                                     <div className="col-lg-3 col-sm-3 col-3 data text-center">
//                                                         {" "}
//                                                         <p className="theme-text-color mb-3 mt-0 admin-input-title d-block position-relative me-3">Path</p>
//                                                     </div>
//                                                     <div className="col-lg-3 col-sm-3 col-3 data text-center">
//                                                         {" "}
//                                                         <p className="theme-text-color mb-3 mt-0 admin-input-title d-block position-relative me-3">Actions</p>
//                                                     </div>
//                                                 </div>

//                                                 <DragDropContext>
//                                                     <Droppable droppableId="menu-items">
//                                                         {(provided) => (
//                                                             <ul {...provided.droppableProps} ref={provided.innerRef}>
//                                                                 {loading ? (
//                                                                     <div className="noRecord">
//                                                                         {" "}
//                                                                         <Response_Loading_processing></Response_Loading_processing>
//                                                                         Loading...
//                                                                     </div>
//                                                                 ) : filteredVideoLists?.length <= 0 ? (  // Use filtered list for rendering
//                                                                     <div className="noRecord">
//                                                                         {" "}
//                                                                         <p>No Sidebar Available !!! </p>
//                                                                     </div>
//                                                                 ) : (
//                                                                     filteredVideoLists?.map((item, index) => (  // Use filtered list for rendering
//                                                                         <Draggable
//                                                                             key={item.id}
//                                                                             draggableId={item.id.toString()}
//                                                                             index={index}
//                                                                         >
//                                                                             {(provided) => (
//                                                                                 <li
//                                                                                     ref={provided.innerRef}
//                                                                                     {...provided.draggableProps}
//                                                                                     {...provided.dragHandleProps}
//                                                                                     className={`bg-white orderborder ${item?.order
//                                                                                         } index ${index + 1} w-100`}
//                                                                                 >
//                                                                                     <div className="row m-0 p-0 align-items-center">

//                                                                                         <div className="col-lg-3 col-sm-3 col-3 data_th">
//                                                                                             <input
//                                                                                                 type="text"
//                                                                                                 className="rs-input form-control-lg"
//                                                                                                 value={item?.title}
//                                                                                                 onChange={(e) => {
//                                                                                                     const newName = e.target.value;
//                                                                                                     const updatedList = [...getVideolists];
//                                                                                                     updatedList[index].title = newName;
//                                                                                                     setVideolists(updatedList);
//                                                                                                 }}
//                                                                                             />
//                                                                                         </div>
//                                                                                         <div className="col-lg-3 col-sm-3 col-3 data_th">

//                                                                                             <input
//                                                                                                 type="text"
//                                                                                                 className="rs-input form-control-lg"
//                                                                                                 value={item?.sub_title}
//                                                                                                 onChange={(e) => {
//                                                                                                     const newName = e.target.value;
//                                                                                                     const updatedList = [...getVideolists];
//                                                                                                     updatedList[index].sub_title = newName;
//                                                                                                     setVideolists(updatedList);
//                                                                                                 }}
//                                                                                             />

//                                                                                         </div>
//                                                                                         <div className="col-lg-3 col-sm-3 col-3 data_th">

//                                                                                             <input
//                                                                                                 type="text"
//                                                                                                 className="rs-input form-control-lg"
//                                                                                                 value={item?.path}
//                                                                                                 onChange={(e) => {
//                                                                                                     const newName = e.target.value;
//                                                                                                     const updatedList = [...getVideolists];
//                                                                                                     updatedList[index].path = newName;
//                                                                                                     setVideolists(updatedList);
//                                                                                                 }}
//                                                                                             />

//                                                                                         </div>
//                                                                                         <div className="col-lg-3 col-sm-3 col-3 data_th text-center">
//                                                                                             <div className="justify-content-between align-items-center">
//                                                                                                 <button className="button-bg-color theme-button-text-color admin-button-text rounded-3 py-2 px-3" onClick={() => handleUpdatevideo(item)}>Update</button>
//                                                                                             </div>
//                                                                                         </div>
//                                                                                     </div>
//                                                                                 </li>
//                                                                             )}
//                                                                         </Draggable>
//                                                                     ))
//                                                                 )}
//                                                                 {provided.placeholder}
//                                                             </ul>
//                                                         )}
//                                                     </Droppable>
//                                                 </DragDropContext>
//                                             </div>
//                                         </div>
//                                     </div>
//                                 </div>
//                             </section>
//                         </div>
//                     </div>
//                 </div>
//             </section>
//         </>
//     );
// }

// export default Label_source_list;
